module.exports = __webpack_public_path__ + "static/media/robbery.67ec26a2.svg";